import { render, staticRenderFns } from "./InheritableField.vue?vue&type=template&id=4e7e20f4"
import script from "./InheritableField.vue?vue&type=script&lang=js"
export * from "./InheritableField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports